<template>
    <div>
        <v-toolbar dense
                   fixed>
            <v-btn router
                   flat
                   to="/viewfreight"
                   class="teal--text darken-2">Kangaruu</v-btn>
            <v-spacer></v-spacer>

            <v-btn small
                   flat
                   icon
                   v-on:click.native="downLoadFile"
                   color="teal">
                <v-icon>get_app</v-icon>
            </v-btn>

            <v-btn v-if="isBroker"
                   small
                   flat
                   icon
                   v-on:click.native="$router.push({ name: 'brokerfreight', params: { shipmentID: freightID } })"
                   color="teal">
                <v-icon>keyboard_backspace</v-icon>
            </v-btn>

            <v-btn v-if="!isBroker"
                   small
                   flat
                   icon
                   v-on:click.native="$router.push({ name: 'shipperfreight', params: { shipmentID: freightID } })"
                   color="teal">
                <v-icon>keyboard_backspace</v-icon>
            </v-btn>
        </v-toolbar>
        <div class="image-frame">
            <object :data="imageURL"
                    type="application/pdf"
                    width="100%"
                    height="100%">
                <iframe :src="imageURL"
                        width="100%"
                        height="100%"
                        style="border: none;">
                    This browser does not support PDFs. Please download the PDF to view it:
                    <a :href="imageURL">Download PDF</a>
                </iframe>
            </object>
        </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: ['imageURL', 'freightID', 'isBroker', 'imageName'],
  components: {},
  methods: {
    downLoadFile () {
      var fileName = this.imageName
      var xhr = new XMLHttpRequest()
      xhr.responseType = 'blob'
      xhr.onload = function (event) {
        var blob = new Blob([xhr.response], { type: 'image/png' })
        console.log(xhr.response)
        let a = document.createElement('a')
        a.style = 'display: none'
        document.body.appendChild(a)
        // Create a DOMString representing the blob
        // and point the link element towards it
        let url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = fileName
        // programatically click the link to trigger the download
        a.click()
        // release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url)
      }
      xhr.open('GET', this.imageURL)
      xhr.send()
    }
  }
}
</script>

<style>
.image-frame {
  position: relative;
  padding-bottom: 75%;
  height: 0;
  overflow: hidden;
}
.image-frame iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
.image-frame object {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ViewImages.vue